import { styled } from 'styled-components';

import failedAnimation from '@/assets/animations/failed.json';
import successAnimation from '@/assets/animations/success.json';
import UnauthorizedIconSVG from '@/assets/icons/401.svg?react';
import NotFoundIconSVG from '@/assets/icons/404.svg?react';
import { Animation } from '@/components/Animation/Animation';

const ErrorIconWrapperSC = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 60px;

  margin-bottom: 30px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    margin-bottom: 40px;
  }

  & > svg {
    width: 210px;
    height: 60px;

    @media (min-width: ${(p) => p.theme.devices.tablet}) {
      width: 294px;
      height: 84px;
    }
  }
`;

export const SuccessIcon = () => <Animation animationData={successAnimation} />;

export const UnauthorizedIcon = () => (
  <ErrorIconWrapperSC>
    <UnauthorizedIconSVG />
  </ErrorIconWrapperSC>
);

export const NotFoundIcon = () => (
  <ErrorIconWrapperSC>
    <NotFoundIconSVG />
  </ErrorIconWrapperSC>
);

export const FailedIcon = () => <Animation animationData={failedAnimation} />;
